import { render, staticRenderFns } from "./SelectedAdministratorButton.vue?vue&type=template&id=88c7d10c&scoped=true&"
import script from "./SelectedAdministratorButton.vue?vue&type=script&lang=ts&"
export * from "./SelectedAdministratorButton.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedAdministratorButton.vue?vue&type=style&index=0&id=88c7d10c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c7d10c",
  null
  
)

export default component.exports